import { OperationStatus, Shift, ShiftState } from '@wilson/interfaces';

export function isShiftDraggable(shift: Shift): boolean {
  return (
    shift.operationalStatus !== OperationStatus.Ongoing &&
    shift.operationalStatus !== OperationStatus.Completed &&
    shift.state !== ShiftState.Submitted &&
    shift.state !== ShiftState.AcceptedTimes &&
    shift.state !== ShiftState.SubmittedToPayrollProvider
  );
}
